module.exports = __webpack_public_path__ + "img/health-case1.579174df.png";